/**
 * Where a user's subscription stands, from an /admin/users row:
 * paid, ending (cancelled, still paid up), trial, expired, canceled or none.
 * The Users page's tabs and its PlanBadge both read it, so they always agree.
 */
export function planState(user) {
  const { subscription_plan: plan, subscription_status: status } = user;
  if (status === 'active' && plan && plan !== 'free_trial') {
    return user.cancel_at_period_end ? 'ending' : 'paid';
  }
  if (status === 'trialing' || (plan === 'free_trial' && status !== 'expired' && status !== 'canceled')) return 'trial';
  if (status === 'expired') return 'expired';
  if (status === 'canceled') return 'canceled';
  return 'none';
}
